import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit/responsive/hooks/useDeviceType';

import { NewReviewModalFooter } from '../../components/NewReviewModal/parts/NewReviewModalFooter';
import { changeStep } from '../../actions/newReview';
import { getIsNextStepAvailable, getIsPrevStepAvailable } from '../../selectors/newReview';
import { stepBackActions } from '../../actions/newReview/stepBackActions';

export const NewReviewModalFooterContainer = () => {
  const deviceType = useDeviceType();
  const dispatch = useDispatch();
  const isNextStepAvailable = useSelector(getIsNextStepAvailable);
  const isPrevStepAvailable = useSelector(getIsPrevStepAvailable);
  const isMobile = deviceType === 'phone';

  const onNextClick = () => {
    dispatch(changeStep());
  };

  const onPrevClick = () => {
    dispatch(stepBackActions());
  };

  return (
    <NewReviewModalFooter
      next={
        <Button
          data-testid="nextstep"
          fullWidth={isMobile}
          size={isMobile ? 'M' : 'XS'}
          disabled={!isNextStepAvailable}
          onClick={onNextClick}
        >
          Продолжить
        </Button>
      }
      prev={
        isPrevStepAvailable ? (
          <Button
            data-testid="prevstep"
            fullWidth={isMobile}
            size={isMobile ? 'M' : 'XS'}
            theme={isMobile ? 'fill_secondary' : 'fill_white_primary'}
            onClick={onPrevClick}
          >
            Назад
          </Button>
        ) : null
      }
    />
  );
};
